var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18557 11.5464C7.93814 11.7938 7.93814 12.2062 8.18557 12.4536L13.5189 17.8144C13.7938 18.0619 14.2062 18.0619 14.4536 17.8144L15.0859 17.1821C15.3333 16.9347 15.3333 16.5223 15.0859 16.2474L10.8522 11.9863L15.0859 7.75258C15.3333 7.47766 15.3333 7.06529 15.0859 6.81787L14.4536 6.18557C14.2062 5.93814 13.7938 5.93814 13.5189 6.18557L8.18557 11.5464Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.c52385c082d737a6e68147599b0f6073.svg";
export { ForwardRef as ReactComponent };